import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	// Flag titles
	newVersion: {
		id: 'quick-reload.new-version-published',
		description: 'Flag title to inform user that a new page version is avilable on reload',
		defaultMessage: 'New version published',
	},
	newComment: {
		id: 'quick-reload.new-comment',
		description: 'Flag title to inform user that a new page comment is avilable on reload',
		defaultMessage: 'New comment',
	},

	// Flag descriptions (comments)
	newComments: {
		id: 'quick-reload.new-comments',
		description: 'Flag title to inform user that multiple new page comments are avilable on reload',
		defaultMessage: '{numComments} new comments',
	},
	somebodyCommented: {
		id: 'quick-reload.somebody-commented',
		description: 'Flag description to inform who added a comment',
		defaultMessage: `{somebody} {commentType, select, comment {commented} other {replied}} {timeAgo}`,
	},
	somebodyCommentedDifferentVersion: {
		id: 'quick-reload.somebody-commented-on-different-version',
		description: 'Flag description to inform who added a comment on a different version',
		defaultMessage: `{somebody} {commentType, select, comment {commented} other {replied}} on a different version {timeAgo}`,
	},
	twoPeopleCommented: {
		id: 'quick-reload.two-people-commented',
		description: 'Flag description to inform that two people have added comments',
		defaultMessage: '{somebody} and {somebodyElse} commented',
	},
	twoPeopleCommentedDifferentVersion: {
		id: 'quick-reload.two-people-commented-on-different-version',
		description:
			'Flag description to inform that two people have added comments on a different version',
		defaultMessage: '{somebody} and {somebodyElse} commented on a different version',
	},
	multiplePeopleCommented: {
		id: 'quick-reload.at-least-three-people-commented',
		description: 'Flag description to inform that multiple people have added comments',
		defaultMessage: `{somebody} and {numOthers, plural, one {# other} other {# others}} {commentType, select, comment {commented} other {replied}} {timeAgo}`,
	},
	multiplePeopleCommentedDifferentVersion: {
		id: 'quick-reload.at-least-three-people-commented-on-different-version',
		description:
			'Flag description to inform that multiple people have added comments on a different version',
		defaultMessage: `{somebody} and {numOthers, plural, one {# other} other {# others}} {commentType, select, comment {commented} other {replied}} on a different version {timeAgo}`,
	},
	newCommentsLoading: {
		id: 'quick-reload.new-comments-loading',
		description: 'Flag description to inform that comments for the page are being loaded',
		defaultMessage: 'Loading comments for this page...',
	},
	newCommentsLoadingBlog: {
		id: 'quick-reload.new-comments-loading-blog',
		description: 'Flag description to inform that comments for the blog post are being loaded',
		defaultMessage: 'Loading comments for this blog post...',
	},
	// Flag descriptions (page edits)
	somebodyPublished: {
		id: 'quick-reload.somebody-published',
		description: 'Flag description to inform who has re-published this page',
		defaultMessage: '{somebody} published a new version of this page',
	},
	twoPeoplePublished: {
		id: 'quick-reload.two-people-published',
		description: 'Flag description to inform that two people have re-published this page',
		defaultMessage: '{somebody} and {somebodyElse} published a new version of this page',
	},
	atLeastThreePeoplePublished: {
		id: 'quick-reload.at-least-three-people-published',
		description: 'Flag description to inform that multiple people have re-published this page',
		defaultMessage:
			'{somebody} and {numOthers, plural, one {# other} other {# others}} published a new version of this page',
	},
	newContentLoading: {
		id: 'quick-reload.new-content-loading',
		description: 'Flag description to inform that page is being reloaded',
		defaultMessage: 'Loading new version of this page...',
	},

	// Flag descriptions (blog post edits)
	somebodyPublishedBlog: {
		id: 'quick-reload.somebody-published-blog',
		description:
			'Text for a notification that another user has published new updates to a blog post that is currently being viewed',
		defaultMessage: '{somebody} published a new version of this blog post',
	},
	twoPeoplePublishedBlog: {
		id: 'quick-reload.two-people-published-blog',
		description:
			'Text for a notification that two other users have both published new updates to a blog post that is currently being viewed',
		defaultMessage: '{somebody} and {somebodyElse} published a new version of this blog post',
	},
	atLeastThreePeoplePublishedBlog: {
		id: 'quick-reload.at-least-three-people-published-blog',
		description:
			'Text for a notification that multiple people (at least three) have all published new updates to a blog post that is currently being viewed',
		defaultMessage:
			'{somebody} and {numOthers, plural, one {# other} other {# others}} published a new version of this blog post',
	},
	newContentLoadingBlog: {
		id: 'quick-reload.new-content-loading-blog',
		description: 'Text for a notification to inform that a blog post is being reloaded',
		defaultMessage: 'Loading new version of this blog post...',
	},

	// Flag actions
	reload: {
		id: 'quick-reload.reload',
		description: 'Button label for button that causes a page reload',
		defaultMessage: 'Reload',
	},
	viewComment: {
		id: 'quick-reload.view-comment',
		description: 'label to prompt user to view the latest comment',
		defaultMessage: 'View their comment',
	},
	viewFirstComment: {
		id: 'quick-reload.view-first-comment',
		description: 'label to prompt user to view the first comment',
		defaultMessage: 'See their {numComments, plural, one {comment} other {comments}}',
	},
});
